import { FC, useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Send, Bot, User } from "lucide-react";
interface Message {
  id: string;
  type: 'user' | 'bot';
  content: string;
  timestamp: Date;
}
interface ConversationPanelProps {
  channelName: string;
}
const ConversationPanel: FC<ConversationPanelProps> = ({
  channelName
}) => {
  const [messages, setMessages] = useState<Message[]>([{
    id: '1',
    type: 'bot',
    content: `Welcome to ${channelName === 'iSPAI' ? 'Giblet' : 'Giblet Construct'} for ${channelName}! I'm ready to help you with knowledge creation and problem-solving.`,
    timestamp: new Date()
  }]);
  const [inputValue, setInputValue] = useState("");
  const handleSendMessage = () => {
    if (inputValue.trim()) {
      const newMessage: Message = {
        id: Date.now().toString(),
        type: 'user',
        content: inputValue,
        timestamp: new Date()
      };
      setMessages(prev => [...prev, newMessage]);
      setInputValue("");

      // Simulate bot response
      setTimeout(() => {
        const botResponse: Message = {
          id: (Date.now() + 1).toString(),
          type: 'bot',
          content: "I'm processing your request. Team GPT integration coming soon!",
          timestamp: new Date()
        };
        setMessages(prev => [...prev, botResponse]);
      }, 1000);
    }
  };
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };
  return <Card className="h-full flex flex-col">
      
      
    </Card>;
};
export default ConversationPanel;